import React from 'react';
import styled from '@emotion/styled';
import CardConfiguracaoUnidade from '../../components/CardConfiguracaoUnidade';

export const Whitelabel = ({ configuracaoUnidade, onChange, disabled }) => {
  return (
    <Container>
      <CardConfiguracaoUnidade
        title="Configurações Whitelabel"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaValorAgendamentoTipoProfissional', label: 'Utiliza o valor do tipo atendimento por profissional saúde?', type: 'switch' },
        ]}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
